// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1YLYN","fontePadrao":"Header_fontePadrao__WtKMC","fonteEspecial":"Header_fonteEspecial__3VT-k"};